import Vue from 'vue';
import CKEditor from '@ckeditor/ckeditor5-vue2';


export default () => {
    Vue.use( CKEditor );
}